import React, { Component } from 'react'
import { PAYMENT_GATEWAY_FIRST_DATA } from '../../constants/app'
class ApplePay extends Component {
  constructor (props) {
    super(props)

    this.state = {
      visiable: false,
    }
  }

  componentDidMount () {
    this.checkCanMakePayment()
  }

  async checkCanMakePayment () {
    let canMakePayments = false

    if (
      window.ApplePaySession &&
      ApplePaySession.canMakePayments()
    ) {
      const merchantIdentifier = process.env.REACT_APP_FIRSTDATA_APPLEPAY_MI

      canMakePayments = await ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier)
    }

    this.setState({ visiable: canMakePayments })
  }

  makePayment () {
    const {
      amount,
      submit,
    } = this.props

    const request = {
      countryCode: 'HK',
      currencyCode: 'HKD',
      supportedNetworks: [
        'visa',
        'masterCard',
        'amex',
        'discover',
      ],
      merchantCapabilities: ['supports3DS'],
      total: {
        label: process.env.REACT_APP_FIRSTDATA_APPLEPAY_MN,
        amount: (amount / 100).toFixed(2),
      },
    }

    const session = new ApplePaySession(3, request)

    session.onpaymentauthorized(this.paymentSuccess)
    session.begin()
  }

  getPrimaryTransactionParams (token) {
    const { amount } = this.props
    const {
      transactionIdentifier,
      paymentData,
    } = token

    const transactionAmount = {
      total: amount / 100,
      currency: 'HKD',
    }
    const walletPaymentMethod = {
      walletType: 'EncryptedApplePayWalletPaymentMethod',
      encryptedApplePay: {
        data: paymentData.data,
        header: {
          applicationDataHash: process.env.REACT_APP_FIRSTDATA_APPLEPAY_ADH,
          ephemeralPublicKey: process.env.REACT_APP_FIRSTDATA_PUB_KEY,
          publicKeyHash: process.env.REACT_APP_FIRSTDATA_APPLEPAY_PUB_HASH,
          transactionId: transactionIdentifier,
        },
        signature: paymentData.signature,
        version: paymentData.version,
        applicationData: paymentData.applicationData,
        merchantId: process.env.REACT_APP_FIRSTDATA_APPLEPAY_MID,
      },
    }

    return {
      requestType: 'WalletPreAuthTransaction',
      transactionAmount,
      walletPaymentMethod,
    }
  }

  async paymentSuccess (event) {
    const { submit } = this.props
    const { token } = event.payment

    try {
      const payload = this.getPrimaryTransactionParams(token)
      submit({ payment: 'applepay', payload, gateway: PAYMENT_GATEWAY_FIRST_DATA })
    } catch (ex) {

    }
  }

  render () {
    const { buttonClass } = this.props
    const { visible } = this.state
    const applePayStyle = {
      '-webkit-appearance': '-apple-pay-button',
      '-apple-pay-button-type': 'plain',
      '-apple-pay-button-style': 'white-outline',
    }

    return <div className={ buttonClass }
      style={ {
        display: 'block',
        opacity: visible ? 1 : 0,
      } }>
      <div lang="zh_HK"
        style={ applePayStyle }
        onClick={ this.makePayment.bind(this) }/>
    </div>
  }
}

export default ApplePay



// WEBPACK FOOTER //
// ./src/components/first-data/ApplePay.js